import { labelOf, type WithLegacyLabel } from 'services/api/legacyCriterionKey';

export interface AICriteriaCategoryOptions {
  id?: string;
  name?: string;
  color?: string;
  order?: number;
}

export class AICriteriaCategory {
  id: string;
  name: string;
  color: string;
  order: number;

  constructor(options?: AICriteriaCategoryOptions) {
    this.id = options?.id ?? '';
    this.name = options?.name ?? '';
    this.color = options?.color ?? '';
    this.order = options?.order ?? 0;
  }
}

export interface AICriteriaOptions extends WithLegacyLabel {
  id?: string;
  label?: string;
  description?: string;
  category?: string;
  categoryId?: string;
  archived?: boolean;
  order?: number;
}

export class AICriteria {
  id: string;
  label: string;
  description: string;
  category: string;
  categoryId: string;
  archived: boolean;
  order: number;

  constructor(options?: AICriteriaOptions) {
    this.id = options?.id ?? '';
    this.label = labelOf(options);
    this.description = options?.description ?? '';
    this.category = options?.category ?? '';
    this.categoryId = options?.categoryId ?? '';
    this.archived = options?.archived ?? false;
    this.order = options?.order ?? 0;
  }
}
